var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getElement } from '../mock';
import styles from './PreviewElements.module.scss';
var PreviewAllElements = function (_a) {
    var sections = _a.sections, title = _a.title, detailMatrixTitle = _a.detailMatrixTitle;
    var nameMapper = {
        matrixStrategy: 'Strategy overview',
        matrixRange: 'Range overview',
        matrixEv: 'EV overview',
        matrixEq: 'Equity overview',
        matrixEqr: 'EqR overview',
        cells: 'Strategy & range cells',
        detailMatrix: 'Hand matrix',
        equityLine: 'Equity line & action bar',
        gradientLine: 'Gradient line',
        cards: 'Cards',
        table: 'Table',
        positions: 'Positions',
    };
    return (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Preview" }), _jsx("div", __assign({ className: styles[title] }, { children: Object.entries(sections).map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return value ? (_jsxs("div", __assign({ id: key }, { children: [title === 'text' ? null : _jsx("span", __assign({ style: { color: '#77767A' } }, { children: nameMapper[key] })), getElement(title, key, detailMatrixTitle)] }))) : null;
                }) }))] }));
};
export default PreviewAllElements;
